import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';


const Index = (props) => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Display Value',
      attr: 'display_value',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Updated At',
      attr: 'updated_at',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_security_amount.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]
  
  const onNewClick = () => {
    navigate('/security_amounts/new');
  }

  const onEditClick = (id) => {
    navigate(`/security_amounts/${id}/edit`)
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_security_amount.name)}>
        <button className="s-btn me-2" onClick={onNewClick} style={{maxWidth: '180px'}}>
          <span>Add New Security Amount</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <ListingPageComponent
    key={PAGES.SecurityAmountsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.SecurityAmountsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Security Amount List'}]}
    listingMutation={getApi('securityAmounts')}
    className="security-amounts-listing-page"
    contentHeading="Security Amounts List - Results"
    headers={headers}
    recordsKey="security_amounts"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['Display Value']}
  />
}

export default Index;
